import React from "react";
import { Link } from "react-router-dom";
import "./NavBar.css";

const NavBar = () => {
  return (
    <div className="nav-div">
      <div className="nav-container">
        <Link to="/">
          <div className="btn-nav">
            Yasiru!
          </div>
        </Link>
        <div className="nav-buttons">
          <Link to="/">
            <div className="btn-nav">Home</div>
          </Link>
          <div className="dropdownNav">
            <button
              className=" dropdown-toggle"
              type="button"
              id="dropdownMenuBtn"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Projects
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li>
                <Link className="dropdown-item" to="/drawings">
                  Drawings/Illustrations
                </Link>
              </li>
              <li>
                <Link className="dropdown-item" to="/it-projects">
                  IT Projects
                </Link>
              </li>
              <li>
                <Link className="dropdown-item" to="/ui-ux">
                  UI/UX Projects
                </Link>
              </li>
              <li>
                <Link className="dropdown-item" to="/3d-works">
                  3D Projects
                </Link>
              </li>
              <li>
                <Link className="dropdown-item" to="/game-dev-works">
                  Game Dev Projects
                </Link>
              </li>
            </ul>
          </div>
          <Link to="/blog">
            <div className="btn-nav">My Blog</div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NavBar;
